import {
  GET_CASE_HISTORY,
  ADD_CASE_HISTORY,
  UPDATE_CASE_READ,
  GET_ONE_CASE,
} from '../types'

const INITIAL_STATE = {
  allCasesHistory: [],
  addedCaseHistory: [],
  readCaseHistory: [],
  getOneCase: [],
  unreadCount: null,
}
const caseHistoryReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case GET_CASE_HISTORY:
      return {
        ...state,
        allCasesHistory: payload.data,
        unreadCount: payload.unreadCount,
      }
    case ADD_CASE_HISTORY:
      return {
        ...state,
        addedCaseHistory: payload.data,
      }
    case UPDATE_CASE_READ:
      return {
        ...state,
        readCaseHistory: payload.data,
      }
    case GET_ONE_CASE:
      return {
        ...state,
        getOneCase: payload.data,
      }
    default:
      return state
  }
}
export default caseHistoryReducer
